<template>
  <div class="order" v-cloak>
    <el-row type="flex" justify="between" :gutter="5">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <userCard :config="cardConfig" @clear-job="clearJob" @saveSuccess="getData()"></userCard>
        </div>
      </el-col>
    </el-row>
    <div class="order-solution">
      <div class="os-list">
        <div class="os-title os-title2" style="width: 100%; display: flex;justify-content: space-between;">
          <!-- <el-row :gutter="24">
            <el-col > -->
          <!-- <div class="left flex-between" style="width: 31%"> -->
          <div class="left flex-between" style="width: 20%">
          <!-- <div class="left flex-between" style="width: 565px"> -->
            <div class="title-control flex-between">
              <i class="el-icon-tickets"></i>
            </div>
            <p class="title">
              {{ $lange == "en" ? "Request Detail" : "详情" }}
            </p>
            <span></span>
          </div>
          <!-- </el-col>
            <el-col :span="12"> -->
          <div class="right" style="display: flex;justify-content: end;">
            <!-- <div class="right_li" v-if="orderData.id" style="width: 31%"> -->
            <!-- <div class="right_li" v-if="orderData.id" style="min-width: 300px"> -->
            <div class="right_li" v-if="orderData.id" >
              <span style="min-width: 45px">{{
                $lange == "en" ? "Status：" : "状态："
              }}</span>
              <template v-if="cardConfig.isOrderEdit">
                <el-select v-model="orderData.status" placeholder="" size="mini">
                  <el-option v-for="item in disposeStatus2" :key="item.value"
                    :label="$lange == 'en' ? item.labelEn : item.label" :value="item.value">
                  </el-option>
                </el-select>
              </template>
              <template v-else>{{
                $lange == "en"
                ? disposeStatus[orderData.status].labelEn
                : disposeStatus[orderData.status].label
              }}</template>
            </div>
            <!-- <div class="right_li" style="width: 300px"> -->
            <div class="right_li" >
              <span style="min-width: 85px" v-if="$lange == 'en'">{{
                $lange == "en" ? "Responsible：" : "处理人："
              }}</span>
              <span style="min-width: 60px" v-if="$lange != 'en'">{{
                $lange == "en" ? "Responsible：" : "处理人："
              }}</span>
              <template v-if="cardConfig.isOrderEdit">
                <el-select v-model="orderData.handlerId" placeholder="" size="mini">
                  <el-option v-for="item in userSelectorList" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </template>
              <template v-else>{{
                showhandlerId(orderData.handlerId)
              }}</template>
            </div>
            <!-- <div style="width: 50%; display: flex; justify-content: flex-end" v-if="isHandleV2"> -->
            <div style=" display: flex; justify-content: flex-end" v-if="isHandleV2">
              <p class="btn-group flex-between" v-if="!cardConfig.isOrderEdit">
                <el-button size="mini" type="primary" @click="editOrder" style="width: 150px">{{ $lange == "en" ? "Edit"
                : "编辑" }}</el-button>
              </p>

              <p class="btn-group flex-between" v-else>
                <el-button size="mini" @click="cancelEdit" style="width: 150px">{{ $lange == "en" ? "Cancel" : "取消"
                }}</el-button>
                <el-button size="mini" type="primary" @click="orderSave" style="width: 150px">{{ $lange == "en" ? "Save"
                : "保存" }}</el-button>
              </p>
            </div>
          </div>
          <!-- </el-col>
          </el-row> -->
        </div>

        <div class="order-content">
          <div class="content-top">
            <div class="excelData flex-between">
              <p style="min-width: 305px">
                {{ $lange == "en" ? "Order" : "请求" }}ID:
                {{ orderId }}
              </p>
              <p>
                {{ $lange == "en" ? "Create Time" : "申请时间" }}:
                {{ orderData.createTime }}
              </p>
              <p v-if="$lange == 'zh'">
                <template v-if="orderData.product">
                  {{ $lange == "en" ? "Product status" : "产品状态" }}:
                  {{ productStatus[orderData.product.status] }}
                </template>
              </p>
              <p v-if="$lange == 'en'">
                <template v-if="orderData.product">
                  {{ $lange == "en" ? "Product status" : "产品状态" }}:
                  {{ productStatusEN[orderData.product.status] }}
                </template>
              </p>
              <p>
                <!-- {{ $lange == "en" ? "Status" : "状态" }}:
                {{ orderStatusFilter }} -->
              </p>
            </div>
            <div class="excelData flex-between">
              <template v-if="!cardConfig.isOrderEdit">
                <p style="min-width: 305px">
                  Job ID: {{ orderData.jobId || "---" }}
                </p>
                <p v-if="$lange == 'zh'">
                  {{ $lange == "en" ? "Machine" : "机器" }}:
                  {{ orderData.machine.machineModel || "---" }}
                </p>
                <p v-if="$lange == 'en'">
                  {{ $lange == "en" ? "Machine" : "机器" }}:
                  {{
                    orderData.machine.machineEnModel
                      ? orderData.machine.machineEnModel
                      : orderData.machine.machineModel || "---"
                  }}
                </p>
                <p>
                  {{ $lange == "en" ? "Abbr" : "缩写" }}:
                  {{ orderData.machine.machineAbbr || "---" }}
                </p>
                <p>COM No: {{ orderData.machine.fiCom || "---" }}</p>
              </template>
              <template v-else>
                <p class="require-class require-class2" style="min-width: 305px">
                  Job ID:
                  <span style="display: inline-block">
                    <el-select size="mini" placeholder="Job ID" @change="jobIdChange" v-model="orderData.jobId">
                      <el-option v-for="item in jobIdArr" :label="item.jobId" :value="item.jobId"
                        :key="item.jobId"></el-option>
                    </el-select>
                  </span>
                </p>
                <p class="require-class require-class2">
                  {{ $lange == "en" ? "Machine" : "机器" }}:
                  <span style="display: inline-block" :key="orderData.jobId">
                    <cc-selector :config="machineSelectorConfig" :value="orderData.machine.id" :placeholder="
                      $lange == 'en' ? 'Please Select Machine' : '请选择机器'
                    " @change="machineChange" />
                  </span>
                </p>

                <p>
                  {{ $lange == "en" ? "Abbr" : "缩写" }}:
                  {{ orderData.machine.machineAbbr || "---" }}
                </p>
                <p>COM No: {{ orderData.machine.fiCom || "---" }}</p>
              </template>
            </div>
            <div class="excelData flex-between">
              <template v-if="!cardConfig.isOrderEdit">
                <p style="min-width: 305px">
                  {{ $lange == "en" ? "Contacts" : "申请人" }}:
                  {{ orderData.userName || "---" }}
                </p>
                <p>
                  {{ $lange == "en" ? "Moblie No." : "联系方式" }}:
                  {{ orderData.phone || "---" }}
                </p>
              </template>
              <template v-else>
                <p class="require-class require-class2">
                  {{ $lange == "en" ? "Contacts" : "申请人" }}:
                  <span style="display: inline-block">
                    <el-select v-model="orderData.userId" size="mini" :placeholder="
                      $lange == 'en'
                        ? 'Please Select Contacts'
                        : '请选择申请人'
                    " clearable @change="contactChange">
                      <el-option v-for="op in contactSelector" :label="op.userName" :value="op.userId"
                        :key="op.userId"></el-option>
                    </el-select>
                  </span>
                </p>
                <p>
                  {{ $lange == "en" ? "MoblieNo." : "联系方式" }}:
                  {{ orderData.phone || "---" }}
                </p>
              </template>

              <span></span>
              <span></span>
            </div>
          </div>
          <div class="content-bottom">
            <el-row :gutter="20">
              <el-col :span="12">
                <div class="left" style="background: rgb(245 247 250); padding: 10px">
                  <div>
                    <span>{{ $lange == "en" ? "Subject" : "问题标题" }}:</span>
                    <div>
                      <template v-if="cardConfig.isOrderEdit">
                        <el-input :placeholder="
                          $lange == 'en'
                            ? 'Please Enter Subject'
                            : '请输入问题标题'
                        " size="mini" v-model="orderData.title"></el-input>
                      </template>
                      <template v-else>{{ orderData.title }}</template>
                    </div>
                  </div>
                  <div>
                    <span>{{ $lange == "en" ? "Description" : "问题描述" }}:</span>
                    <div>
                      <template v-if="cardConfig.isOrderEdit">
                        <el-input :placeholder="
                          $lange == 'en'
                            ? 'Please Enter  Description'
                            : '请输入问题描述'
                        " size="mini" type="textarea" :rows="4" v-model="orderData.description"></el-input>
                      </template>
                      <template v-else>
                        <div style="white-space: pre-wrap" v-html="orderData.description"></div>
                      </template>
                    </div>
                  </div>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="right">
                  <span>{{ $lange == "en" ? "Images" : "图片" }}:</span>
                  <div class="image-lists flex-between">
                    <div class="list" v-for="(item, ind) in postForm.accessoryInfoList"
                      @click="showImage(item.accessoryUrl)" :style="
                        'background:url(' +
                        item.accessoryUrl +
                        ') no-repeat center / cover'
                      ">
                      <div class="del-image flex-between" v-if="cardConfig.isOrderEdit" @click.stop="deleteImage(ind)">
                        X
                      </div>
                    </div>
                    <div class="list order-upload-image" v-if="cardConfig.isOrderEdit">
                      <cc-uploader :config="uploaderConf2" uploadType="dottedLine" @upload-success="uploadTrue"
                        :isMultiple="true" />
                    </div>
                  </div>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>

        <!--处理方案--->
        <div>
          <div class="os-title">
            <el-row :gutter="40">
              <el-col :span="18">
                <div class="left flex-between">
                  <div class="title-control flex-between" @click="showHandleData = !showHandleData">
                    <i class="el-icon-arrow-up" v-if="!showHandleData"></i>
                    <i class="el-icon-arrow-down" v-else></i>
                  </div>
                  <p class="title">
                    {{ $lange == "en" ? "Request Processing" : "处理方案" }}
                  </p>
                </div>
              </el-col>
              <!-- <el-col :span="6">
                  <div class="right flex-between">
                    <template v-if="showHandleData"> </template>
                    <template v-else>
                      <span></span>
                      <el-button
                        type="primary"
                        size="mini"
                        @click="showHandleData = true"
                        >{{
                          $lange == "en" ? "View Detail" : "查看"
                        }}</el-button
                      >
                    </template>
                  </div>
                </el-col> -->
            </el-row>
          </div>

          <el-collapse-transition>
            <div class="os-content" v-show="showHandleData" style="padding: 0 0 0 20px">
              <div class="select-box">
                <div style="display: inline-block">
                  <el-select v-model="orderData.priority" @change="priorityChange"
                    :disabled="cardConfig.isOrderEdit ? false : true" size="mini"
                    :placeholder="$lange == 'en' ? 'Priority' : '优先级'">
                    <el-option :label="$lange == 'en' ? 'Low' : '低'" value="低"></el-option>
                    <el-option :label="$lange == 'en' ? 'Middle' : '中'" value="中"></el-option>
                    <el-option :label="$lange == 'en' ? 'High' : '高'" value="高"></el-option>
                  </el-select>
                </div>
                <div style="display: inline-block">
                  <el-select v-model="orderData.requestType" size="mini" @change="workTypeChange"
                    :disabled="cardConfig.isOrderEdit ? false : true" placeholder="请求类型">
                    <el-option :label="
                      $lange == 'en' ? 'Information Inquiry' : '一般咨询'
                    " :value="0"></el-option>
                    <el-option :label="$lange == 'en' ? 'Spare Part Order' : '配件申请'" :value="1"></el-option>
                    <el-option :label="$lange == 'en' ? 'Machine Failures' : '问题故障'" :value="2"></el-option>
                  </el-select>
                </div>
                <template v-if="orderData.requestType == 2">
                  <div style="display: inline-block">
                    <cc-selector :config="malfunctionSelectorConfig" v-model="handleData.malfunctionId" :placeholder="
                      $lange == 'en' ? 'Fault classification' : '故障分类'
                    " @change="malfunctionChange" :isDisable="cardConfig.isOrderEdit ? false : true" />
                  </div>
                  <div style="display: inline-block">
                    <cc-selector :config="problemSelectorConfig" v-model="handleData.problemId" @change="problemChange"
                      :isDisable="cardConfig.isOrderEdit ? false : true" :placeholder="
                        $lange == 'en' ? 'Source of the issue' : '问题来源'
                      " />
                  </div>
                </template>
              </div>

              <div class="os-con-list engineer-remark flex-between" style="
                  background: rgb(245, 247, 250);
                  padding: 10px;
                  margin-top: 10px;
                ">
                <p class="title">
                  {{ $lange == "en" ? "Solution" : "解决方案" }}:
                </p>
                <div class="remark-lists">
                  <template v-if="cardConfig.isOrderEdit">
                    <div style="background: #fff">
                      <cc-editor v-model="handleData.replyContent"></cc-editor>
                    </div>
                  </template>

                  <div v-else class="html-context" v-html="
                    handleData.replyContent ? handleData.replyContent : ''
                  "></div>
                </div>
              </div>
              <div class="push_mes" v-if="
                orderData.schemeList &&
                orderData.schemeList.length > 0 &&
                orderData.schemeList[0].id &&
                !cardConfig.isOrderEdit &&
                handleData.replyContent &&
                isHandleV2
              ">
                <el-button type="primary" size="mini" @click="saveProductFee" style="width: 150px">{{
                  $lange == "en" ? "Send to customer" : "推送客户"
                }}</el-button>
              </div>
            </div>
          </el-collapse-transition>
        </div>
        <!--处理方案--->
      </div>
    </div>
    <!--配件订单-->
    <template v-if="orderData.id">
      <orderMountings :orderData="orderData" @updateOrder="updateOrder" :isHandleV2="isHandleV2"></orderMountings>
    </template>
    <!--外派订单-->
    <template v-if="orderData.id">
      <orderAssignment :orderData="orderData" @updateOrder="updateOrder" :isHandleV2="isHandleV2"></orderAssignment>
    </template>

    <template v-if="orderData.id">
      <orderRemark :orderData="orderData" @updateOrder="updateOrder"></orderRemark>
    </template>
    <el-dialog :visible.sync="showImageFlag" width="80%" append-to-body>
      <img :src="nowShowImageUrl" style="display: block; margin: 0 auto; width: 100%" alt />
    </el-dialog>

    <el-dialog :visible.sync="cancelRemarkFlag" width="50%" append-to-body>
      <h3 class="cancelRemark_title">{{ $lange == "en" ? `Are you sure to set the request as "cancel"？` :
      "请确认是否取消本服务请求吗?" }}</h3>
      <el-input type="textarea" placeholder="" v-model="cancelRemarkText" :autosize="{ minRows: 10, maxRows: 10 }">
      </el-input>
      <div class="cancelRemark_btn">
        <el-button size="small" @click="cancelRemarkFlag = false">{{ $lange == "en" ? "No" : "取消" }}</el-button>
        <el-button type="primary" size="small" @click="cancelRemark">{{ $lange == "en" ? "Yes" : "确认" }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UserCard from "../../../components/UserCard";
import orderRemark from "./orderRemark";
import orderMountings from "./orderMountings";
import orderAssignment from "./orderAssignment";
import moment from "moment";
import axios from "axios";
export default {
  name: "OrderComponent",
  components: {
    UserCard,
    orderRemark,
    orderMountings,
    orderAssignment,
  },
  props: {
    fileData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    orderIdV2: String,
    isDialog: Boolean,
    // isHandleV2: Boolean, // true 可處理，false 只能修改備註
  },
  computed: {
    orderStatusFilter() {
      // let obj = this.orderData;
      // let res = this.orderStatus[obj.status].title;
      // if (obj.status === 1 && obj.handleStatus === 1) {
      //   res = "配件准备中";
      // }
      // if (obj.status === 1 && obj.handleStatus === 2) {
      //   res = "现场服务安排中";
      // }
      // return res;
      let obj = this.orderData;
      let res = this.disposeStatus[obj.status].label;
      return res;
    },
  },
  data() {
    return {
      productStatus: ["新增", "安装", "保内", "保外"],
      productStatusEN: ["New", "Installation", "Warranty", "Out of Warranty"],
      //工单客户卡片
      cardConfig: {
        id: false,
        api: "admin/fsb/customer/save",
        customerName: "", // 公司的中文名称
        englishName: "", // 公司的英文名称
        isOrderEdit: false,
        isOrderCreate: false,
        isOrder: true,
        customerId: "",
        image: "", //图片
        formLists: [
          //表单内容
          {
            name: this.$lange == "en" ? "ID" : "客户ID",
            value: "",
            key: "customerNo",
          },
          {
            name: this.$lange == "en" ? "Credit Rating" : "信用等级",
            value: "",
            key: "creditLevel",
          },
          {
            name: this.$lange == "en" ? "Customer Satisfaction" : "年度满意度",
            value: "",
            key: "",
          },
          {
            name: this.$lange == "en" ? "Spare Part discount" : "配件折扣",
            value: "",
            key: "discount",
          },
          {
            name: this.$lange == "en" ? "Address" : "地址",
            value: "",
            key: "customerAddress",
          },
          {
            name: this.$lange == "en" ? "Customer Manager" : "客户经理",
            value: "",
            key: "customerManager",
          },
          {
            name: this.$lange == "en" ? "Create time" : "创建时间",
            type: "input",
            value: "",
            key: "createTime",
          },
        ],
      },
      nowShowImageUrl: "", //当前放大图片Url
      showImageFlag: false, //点击放大工单图片
      //机器选择的下拉
      machineSelectorConfig: {
        api: "admin/fsb/machine/query?jobId=null&pageSize=999&isAsc=true",
        isDisable: false,
        valProp: "id",
        labelProp: this.$lange == "en" ? "machineEnModel" : "machineModel",
        valueType: "String",
        width: "100%",
      },
      //jobId选择的下拉
      jobIdArr: [],
      principalSelector: [],
      contactSelector: [], //申请人选择的下拉
      orderStatus: [
        { title: "全部" },
        { title: "申请中" },
        { title: "处理中" },
        { title: "客户处理中" },
        { title: "已完成" },
        { title: "已评价" },
        { title: "已关闭" },
      ], //工单状态
      orderId: "", //当前工单id
      showHandleData: true, //控制工单处理方案的展示
      //工单处理方案的表单
      handleData: {
        machineId: "",
        orderType: "",
        malfunction: null,
        problem: null,
        problemId: "",
        malfunctionId: "",
        remarkArr: [],
        replyContent: "",
        isExpatriate: false,
        isParts: false,
        notConfirm: false, //是否不需要客户确认方案，直接通过
        sendProblemParts: false,
      },
      //故障分类的下拉
      malfunctionSelectorConfig: {
        valueType: "String",
        api:
          "admin/fsb/work/order/attribute/query?code=0&pageSize=999&isAsc=true&type=" +
          (this.$lange == "en" ? "1" : "0"),
        valProp: "id",
        labelProp: "name",
        width: "100%",
        isDisable: true,
      },
      //问题选择的下拉
      problemSelectorConfig: {
        valueType: "String",
        api:
          "admin/fsb/work/order/attribute/query?code=1&pageSize=999&isAsc=true&type=" +
          (this.$lange == "en" ? "1" : "0"),
        valProp: "id",
        labelProp: "name",
        width: "100%",
        isDisable: true,
      },

      //当前的工单信息
      orderData: {
        jobId: "",
        phone: "",
        title: "",
        description: "",
        machine: {
          machineName: "",
          machineAbbr: "",
          fiCom: "",
        },
        customer: {
          id: "",
        },
      },
      lastOrder: {}, //备份获取的工单信息，当改动后点击取消，复原一切修改
      //工单 创建/修改 上传的表单信息
      postForm: {
        title: "",
        description: "",
        customerId: "",
        machineId: "",
        userId: "",
        userName: "",
        phone: "",
        accessoryInfoList: [],
      },
      userData: {},

      uploaderConf2: this.$uploadUtils.config, //文件上传需要

      //v2版本新加
      disposeStatus: [
        {
          label: "申请中",
          value: 0,
          labelEn: "New",
        },
        {
          label: "处理中",
          value: 1,
          labelEn: "Processing",
        },
        {
          label: "观察中",
          value: 2,
          labelEn: "Monitoring",
        },
        {
          label: "已完成",
          value: 3,
          labelEn: "Completed",
        },
        {
          label: "已关闭",
          value: 4,
          labelEn: "Close",
        },
        {
          label: "已取消",
          labelEn: "Cancelled",

          value: 5,
        },
      ],
      disposeStatus2: [
        {
          label: "申请中",
          labelEn: "New",
          value: 0,
        },
        {
          labelEn: "Processing",
          label: "处理中",
          value: 1,
        },
        {
          label: "观察中",
          labelEn: "Monitoring",
          value: 2,
        },
        {
          label: "已完成",
          labelEn: "Completed",
          value: 3,
        },
        // {
        //   label: "已关闭",
        //   value: 4,
        // },
        {
          label: "已取消",
          labelEn: "Cancelled",
          value: 5,
        },
      ],

      userSelectorList: [],

      cancelRemarkFlag: false,
      cancelRemarkText: "",

      fromData: {},
      isHandleV2: false,
    };
  },
  methods: {
    showhandlerId(e) {
      if (e == 0) {
        return "";
      }
      let name = e;
      for (let index = 0; index < this.userSelectorList.length; index++) {
        if (this.userSelectorList[index].id == e) {
          name = this.userSelectorList[index].name;
          break;
        }
      }
      return name;
    },
    getUserList() {
      // let api = `admin/fsb/work/order/queryRoleSameUserList?roleTips=engineer&pageSize=999&isAsc=true`;
      let api = `admin/fsb/work/order/queryHandlerUser?pageSize=999&isAsc=true`;
      this.ccRequest
        // .do(api, ["engineer", "projectManager", "technicalSupport"], "POSTJSON")
        .do(api, ["projectManager", "technicalSupport"], "POSTJSON")
        .then((res) => {
          this.userSelectorList = res;
        });
    },
    getTabText() {
      this.ccRequest
        .do("admin/dict/pageTree", { code: "productStatus" }, "GET")
        .then((res) => {
          let productStatus = [];
          let productStatusEN = [];
          if (res.rows && res.rows.length > 0) {
            for (let index = 0; index < res.rows[0].children.length; index++) {
              if (this.$lange == "zh") {
                productStatus.push(res.rows[0].children[index].title);
              } else {
                if (
                  res.rows[0].children[index].extraData &&
                  res.rows[0].children[index].extraData[this.$lange]
                ) {
                  productStatusEN.push(
                    res.rows[0].children[index].extraData[this.$lange]
                  );
                } else {
                  productStatus.push(res.rows[0].children[index].title);
                }
              }
            }
          }
          this.productStatus = productStatus;
          this.productStatusEN = productStatusEN;
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },

    deleteImage(idx) {
      this.postForm.accessoryInfoList.splice(idx, 1);
    },
    //编辑的时候获取一下jobId
    editOrder() {
      this.cardConfig.isOrderEdit = true;
      this.getJobId();
      this.machineSelectorConfig.api = `admin/fsb/machine/query?jobId=${this.orderData.jobId}&pageSize=999&isAsc=true`;

      this.malfunctionSelectorConfig.isDisable = false;
      this.problemSelectorConfig.isDisable = false;
      this.showHandleData = true;
      //恢復原始數據
      this.handleData.replyContent = this.orderData.replyContent;
    },
    //推送解决方案给客户
    saveProductFee() {
      this.$confirm("你当前的操作会给客户推送通知", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let data = this.orderData;
          let pData = {
            workOrderLogId: data.schemeList[0].workOrderLogList[0].id,
          };
          this.ccRequest
            .do("admin/fsb/work/order/pushCustomer", pData, "GET")
            .then((res) => {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.updateOrder(["remarkList"]);
            })
            .catch((err) => {
              this.$message.error(err.response.data.message);
            });
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },

    //获取申请人
    getContact() {
      let data = {
        workOrderId: this.orderId,
        customerId: this.orderData.customer.id,
        jobId: this.orderData.jobId,
        pageSize: 999,
        isAsc: true,
      };
      // this.orderData.userId = "";
      this.ccRequest
        .do("admin/fsb/work/order/queryApplicant", data, "GET")
        .then((res) => {
          this.contactSelector = res;
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    //获取负责人
    getPrincipal() {
      let data = {
        // roleTips: "projectmanager"
        roleTips: "technicalSupport",
      };
      this.ccRequest
        .do("admin/fsb/work/order/queryUserList", data, "GET")
        .then((res) => {
          this.principalSelector = res.rows;
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    //获取jobId
    getJobId() {
      let data = {
        pageSize: 999,
        customerId: this.orderData.customer.id,
      };
      this.ccRequest
        .do("admin/fsb/product/query", data, "GET")
        .then((res) => {
          this.jobIdArr = res.rows;
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },

    //展示大图
    showImage(url) {
      this.nowShowImageUrl = url;
      this.showImageFlag = true;
    },

    //工单类型修改
    workTypeChange(res) { },
    //优先级修改
    priorityChange(res) {
      // if (!res) {
      //   return false;
      // }
      // let data = {
      //   priority: res,
      //   id: this.orderData.id,
      // };
      // this.ccRequest
      //   .do("admin/fsb/work/order/save", data, "POSTJSON")
      //   .then((res) => {})
      //   .catch((err) => {
      //     this.$message.error(err.response.data.message);
      //   });
    },

    // 问题来源选项
    problemChange(res) {
      console.log("不保存");
    },
    // 故障分类选择
    malfunctionChange(res) {
      console.log("不保存");
    },

    // 取消编辑
    cancelEdit() {
      if (this.$router.history.current.name == "OrderCreate") {
        this.$router.push({
          name: "OrderList",
        });
        return false;
      }
      //恢復原始數據
      let lastOrder = JSON.parse(this.lastOrder);
      this.orderData = {
        ...lastOrder,
      };
      this.handleData.replyContent = this.orderData.replyContent;
      this.cardConfig.isOrderEdit = false;

      this.malfunctionSelectorConfig.isDisable = true;
      this.problemSelectorConfig.isDisable = true;
    },
    // 修改工单保存
    orderSave() {
      console.log(this.postForm, this.orderData.status);

      let data = this.postForm;
      data.workOrderId = this.orderData.id;
      data.customerId = this.orderData.customerId;
      data.userName = this.orderData.userName;
      data.title = this.orderData.title;
      data.description = this.orderData.description;
      data.phone = this.orderData.phone;
      data.userId = this.orderData.userId;
      data.status = this.orderData.status;

      data.priority = this.orderData.priority;
      data.requestType = this.orderData.requestType;
      data.replyContent = this.handleData.replyContent;
      if (data.requestType == 2) {
        data.malfunctionId = this.handleData.malfunctionId;
        data.problemId = this.handleData.problemId;
      }

      // data.principalId = this.orderData.principalId; //移到解决方案的外派服务单了 暂时隐藏
      if (!data.customerId) {
        this.$message({
          type: "error",
          message: "请选择客户",
        });
        return false;
      }
      if (data.userName == "") {
        this.$message({
          type: "error",
          message: "申请人不能为空",
        });
        return false;
      }
      if (data.machineId == "") {
        this.$message({
          type: "error",
          message: "机器不能为空",
        });
        return false;
      }
      if (data.title == "") {
        this.$message({
          type: "error",
          message: "问题标题不能为空",
        });
        return false;
      }
      if (data.description == "") {
        this.$message({
          type: "error",
          message: "问题描述不能为空",
        });
        return false;
      }
      if (data.jobId.length < 1) {
        this.$message({
          type: "error",
          message: "jobId不能为空",
        });
        return false;
      }
      // if (data.handlerId == "") {
      //   this.$message({
      //     type: "error",
      //     message: "处理人不能为空",
      //   });
      //   return false;
      // }
      if (data.replyContent === "" && this.orderData.replyContent) {
        this.$message({
          type: "error",
          message: "解决方案不能为空",
        });
        return false;
      }

      if (data.requestType == 2) {
        if (data.malfunctionId === "") {
          this.$message({
            type: "error",
            message: "故障分类不能为空",
          });
          return false;
        }
        if (data.problemId === "") {
          this.$message({
            type: "error",
            message: "问题来源不能为空",
          });
          return false;
        }
      }

      let from = {
        workOrder: {
          ...data,
          status: this.orderData.status,
        },
        handleType: 0,
        handlerId: this.orderData.handlerId,
        replyContent: data.replyContent,
        workOrderId: this.orderData.id,
      };
      //處理人操作時
      if (this.isHandleV2) {
        from.operationType = 1;
      }
      this.fromData = from;
      if (data.status == 5) {
        this.cancelRemarkFlag = true;
        this.cancelRemarkText = "";
        return false;
      }
      this.orderSaveV2();
      // if (data.requestType == 2) {
      //   if (data.malfunctionId === "") {
      //     this.$message({
      //       type: "error",
      //       message: "故障分类不能为空",
      //     });
      //     return false;
      //   }
      //   if (data.problemId === "") {
      //     this.$message({
      //       type: "error",
      //       message: "问题来源不能为空",
      //     });
      //     return false;
      //   }
      // }
    },

    cancelRemark() {
      this.fromData.workOrder.cancelRemark = this.cancelRemarkText;
      this.orderSaveV2();
    },

    orderSaveV2() {
      // console.log(this.fromData,'this.fromData');
      let text = ['确认修改请求详情？', '确定', '取消', '提示'];
      // let enText = ['Save the change?‘,’Yes', 'No', 'Tips'];
      let enText = ['Save the change?','Yes', 'No', 'Tips'];
      let t = text
      if (
        this.$lange == "en"
      ) {
        t = enText
      }

      this.$confirm(t[0], t[3], {
        confirmButtonText: t[1],
        cancelButtonText: t[2],
        type: "warning",
      })
        .then(() => {
          this.ccRequest
            .do("admin/fsb/work/order/log/save", this.fromData, "POSTJSON")
            .then((res) => {
              this.getOrderData();

              this.$message({
                type: "success",
                message: "操作成功",
              });
              this.malfunctionSelectorConfig.isDisable = true;
              this.problemSelectorConfig.isDisable = true;
              this.cardConfig.isOrderEdit = false;
              this.cancelRemarkFlag = false;
              this.updateOrder(["remarkList", "isHandle"]);
            })
            .catch((res) => {
              this.cardConfig.isOrderEdit = true;
              this.$message({
                type: "warning",
                message: res.response.data.message,
              });
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 机器选择
    machineChange(res) {
      this.postForm.machineId = res;
      let data = {
        id: res,
      };
      this.ccRequest.do("admin/fsb/machine/get", data, "GET").then((res2) => {
        this.orderData.machine.machineModel = res2.machineModel;
        this.orderData.machine.machineAbbr = res2.machineAbbr;
        this.orderData.machine.fiCom = res2.fiCom;
      });
    },
    //申请人选择 --- 获取手机号码
    contactChange(res) {
      for (let i in this.contactSelector) {
        if (this.contactSelector[i].userId === res) {
          this.postForm.userId = res;
          this.orderData.userId = res;
          this.orderData.phone = this.contactSelector[i].phone;
          this.orderData.userName = this.contactSelector[i].userName;
        }
      }
    },
    // jobId选择
    jobIdChange(res) {
      console.log(this.orderData, res);
      this.orderData.jobId = res;
      this.postForm.jobId = res;
      if (res.length > 0) {
        this.postForm.machineId = "";
        this.orderData.machine.id = "";
        this.machineSelectorConfig.api = `admin/fsb/machine/query?jobId=${res}&pageSize=999&isAsc=true`;
        this.getContact();
      }
    },
    // 工单上传图片成功
    uploadTrue(res) {
      this.postForm.accessoryInfoList.push({
        accessoryUrl: res,
      });
    },

    //选择 客户后清除jobId， 避免出现重复
    clearJob(customer) {
      // this.customerData = customer;
      let postForm = {
        title: "",
        description: "",
        customerId: customer.id,
        machineId: "",
        jobId: "",
        userId: "",
        userName: "",
        phone: "",
        accessoryInfoList: [],
      };

      if (customer.productList != "") {
        this.orderData.jobId = customer.productList[0].jobId;
        this.orderData.userName = "";
        this.orderData.machine.machineModel = "";
        postForm.jobId = customer.productList[0].jobId;
        this.machineSelectorConfig.api = `admin/fsb/machine/query?jobId=${customer.productList[0].jobId}&pageSize=999&isAsc=true`;
      }
      this.postForm = postForm;
      this.orderData.customer.id = customer.id;
      this.getContact();
      this.getJobId();
    },
    //获取工单信息
    getOrderData() {
      let data = {
        id: this.orderId,
      };

      this.ccRequest
        .do("admin/fsb/work/order/get", data, "GET")
        .then((res) => {
          this.machineSelectorConfig.api = `admin/fsb/machine/query?jobId=${res.jobId}&pageSize=999&isAsc=true`;
          if (res.principalId != "") {
            res.principalId *= 1; //兼容下拉框  显示出来的是id
          }
          this.postForm.machineId = res.machine.id;
          if (!res.machine) {
            res.machine = {
              machineModel: "",
              machineAbbr: "",
              fiCom: "",
            };
          }
          //这块的兼容是为了详情的时候 没有关联问题来源跟故障分类的空对象情况
          if (!res.malfunctionAttribute) {
            res.malfunctionAttribute = {
              name: "",
            };
          }
          if (!res.problemAttribute) {
            res.problemAttribute = {
              name: "",
            };
          }
          if (res.handlerId == 0) {
            res.handlerId = "";
          }

          this.orderData = res;
          console.log(this.orderData, "aaaaaa");
          this.cardConfig.customerName = res.customer.customerName;
          this.cardConfig.englishName = res.customer.englishName;
          this.cardConfig.image = res.customer.imageUrl;
          this.cardConfig.customerId = res.customer.id;
          this.handleData.replyContent = res.replyContent;
          this.handleData.notConfirm = res.schemeList[0].notConfirm === 1;
          for (let i in this.cardConfig.formLists) {
            if (
              this.cardConfig.formLists[i].key &&
              this.cardConfig.formLists[i].key.length > 0
            ) {
              this.cardConfig.formLists[i].value =
                res.customer[this.cardConfig.formLists[i].key];
            }
            if (this.cardConfig.formLists[i].key === "discount") {
              this.cardConfig.formLists[i].value /= 10;
            }
          }

          this.handleData.problemId = res.problemId;
          this.handleData.malfunctionId = res.malfunctionId;
          this.postForm.accessoryInfoList = res.accessoryInfoList;
          this.postForm.jobId = res.jobId;
          this.lastOrder = JSON.stringify(res); //用于解决编辑后取消 的对象复制问题
          this.isHandleV2 = res.isHandle;
          this.getContact();
          this.getPrincipal();
          // console.log(res)
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },
    //更新工单信息
    updateOrder(e) {
      let data = {
        id: this.orderId,
      };

      this.ccRequest
        .do("admin/fsb/work/order/get", data, "GET")
        .then((res) => {
          // for (let index = 0; index < e.length; index++) {
          //   this.orderData[e[index]] = res[e[index]];
          // }
          if (res.handlerId == 0) {
            res.handlerId = "";
          }
          this.isHandleV2 = res.isHandle;
          this.orderData = res;
        })
        .catch((res) => {
          this.$message({
            type: "error",
            message: res.response.data.message,
          });
        });
    },

    getUserData() {
      // this.ccRequest
      //   .do("validate", {}, "GET")
      //   .then((res) => {
      //     this.userData = res;
      this.getOrderData();
      // if (res.roleTips == "accessoriesSpecialist") {
      // this.machineSelectorConfig.isDisable = true;// 暫時隱藏
      //     this.malfunctionSelectorConfig.isDisable = true;
      //     this.problemSelectorConfig.isDisable = true;
      //   }
      // })
      // .catch((err) => {
      //   this.$message.error(err.response.data.message);
      // });
    },
    getData() {
      this.getUserData();
    },
  },
  mounted() {
    if (this.isDialog) {
      this.orderId = this.orderIdV2;
    } else if (this.$route.query.id) {
      this.orderId = this.$route.query.id;
    }

    this.getData();
    this.getTabText();
    this.getUserList();
  },
};
</script>

<style lang="scss">
/*.el-scrollbar__wrap{*/
/*    overflow-x: hidden !important;*/
/*}*/
.order-upload-image {
  position: relative;
  border: none !important;

  .dottedUpload {
    min-width: 100%;
    border: none;
  }
}

.html-context img {
  max-width: 400px;
}
</style>
<style scoped lang="scss">
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.font-color-success {
  color: #67c23a;
}

.edit-parts {
  >div {
    justify-content: flex-start;
    margin-bottom: 20px;

    span {
      width: 60px;
      margin-right: 10px;
      text-align: right;
    }
  }
}

.order {
  .table-box {
    background: #ffffff;
    margin-top: 20px;

    .table-title {
      padding: 10px 20px;

      .left {
        display: flex;
        align-items: center;

        .add-contacts {
          font-size: 12px;
          padding: 5px;
          margin-left: 15px;
        }
      }

      .show-btn {
        font-size: 12px;
        background: #e4e4e4;
        padding: 3px 10px;
        cursor: pointer;
      }
    }
  }
}

.order-content {
  margin-top: 20px;
  background: #ffffff;
  padding: 20px;

  .content-top {
    .excelData {
      margin-bottom: 15px;
      position: relative;

      >* {
        flex: 0 25%;
      }

      .btn-group {
        position: absolute;
        right: 0;
        top: 0;
        justify-content: flex-end;
      }

      /*&:nth-child(2){*/
      /*    >p:last-child{*/
      /*        flex: 1;*/
      /*        margin-left: 380px;*/
      /*    }*/
      /*}*/
      /*&:last-child{*/
      /*    max-width: 81.5%;*/
      /*}*/
    }
  }

  .content-bottom {
    margin-top: 20px;

    .left {
      >div {
        display: flex;

        &:last-child {
          margin-top: 20px;
        }

        >div {
          margin-left: 10px;
          flex: 1;
        }
      }
    }

    .right {
      display: flex;

      .image-lists {
        flex: 1;
        justify-content: flex-start;
        flex-wrap: wrap;

        .list {
          width: 80px;
          height: 80px;
          cursor: pointer;
          margin-left: 10px;
          border-radius: 5px;
          position: relative;

          .del-image {
            width: 20px;
            height: 20px;
            line-height: 0;
            justify-content: center;
            position: absolute;
            right: 0;
            top: 0;
            border: 1px solid #f00;
            color: #f00;
            font-size: 14px;
            border-radius: 50%;
            transform: translateX(50%) translateY(-50%);
            cursor: pointer;
          }

          img {
            width: 100%;
            display: block;
          }

          margin-bottom: 20px;
          border: 1px dotted #ccc;
        }
      }
    }
  }
}

.create-btn {
  border-top: 1px dotted #ccc;
  justify-content: center;
  padding: 15px 0;
  padding-bottom: 0;
  background: #ffffff;
  flex-wrap: wrap;

  .history-msg {
    p {
      color: #1ab394;
    }

    width: 100%;
    padding: 15px;
    padding-top: 0;
    border-bottom: 1px dotted #ccc;
  }

  .history-lists {
    width: 100%;
    padding: 15px;
    padding-top: 0;
    color: #6f6f6f;

    .list-border {
      border-left: 1px solid #e4e4e4;
      max-width: 80%;
    }

    .list {
      position: relative;
      display: flex;
      margin-top: 15px;
      padding: 0 15px;

      >*:not(.msg-context) {
        margin-top: 12px;
      }

      .left-icon {
        width: 10px;
        position: absolute;
        left: 0;
        top: 0;
        transform: translateX(-50%) translateY(50%);
        height: 10px;
        background: #e4e4e4;
        border-radius: 50%;
      }

      .user-msg {
        margin-left: 10px;
        line-height: 16px;
      }

      .msg-context {
        flex: 1;
        margin-left: 10px;
        border: 1px solid #e4e4e4;
        padding: 10px;
        font-size: 12px;

        .title-text {
          color: #282828;
          font-size: 14px;
        }

        .text,
        .text-list {
          margin-top: 3px;
        }

        .top {}

        .bottom {
          margin-top: 15px;
          max-width: 40%;
          align-items: flex-start;

          &>* {
            flex: 0 45%;
          }

          .left,
          .right {
            height: 100%;
          }

          .text-list {}
        }
      }
    }
  }
}

.order-solution {
  background: #ffffff;
  margin-top: 5px;

  .os-list {
    padding: 20px;
    // border-bottom: 1px dotted #ccc;
    border-bottom: 10px solid #f3f3f4;
    border-top: 1px solid #f3f3f4;

    .os-title {
      .left {
        justify-content: flex-start;

        >* {
          margin-left: 80px;
        }

        .title-control {
          padding: 0px;
          border-radius: 5px;
          border: 1px solid #e4e4e4;
          width: 24px;
          height: 24px;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
          margin-left: 0;

          &~.title {
            font-weight: bolder;
            color: #6f6f6f;
            width: 200px;
          }
        }

        .title {
          font-size: 18px;
          margin-left: 20px;
        }
      }
    }

    .select-box {
      margin-top: 20px;

      >div {
        margin-right: 20px;
        max-width: 150px;
      }
    }

    .os-content {
      .os-con-list {
        padding-top: 20px;

        .title {
          font-size: 16px;
        }

        &.machine-order {
          border-top: 1px dotted #e4e4e4;
          margin-top: 20px;

          .title {
            .btn-add-machine {
              margin-left: 15px;
            }

            .btn-need {
              margin-left: 65px;
            }
          }
        }

        .total-context {
          justify-content: flex-end;
          margin-top: 15px;

          >div {
            margin-left: 80px;

            >span {
              margin-left: 10px;
            }

            &.file-upload {
              span {
                margin-right: 20px;
              }
            }
          }
        }

        .download-file {
          text-decoration: underline;
          cursor: pointer;

          &:hover {
            color: #1ab394;
          }
        }

        &.expatriate-context {
          justify-content: flex-start;

          p {
            display: flex;
            align-items: center;
            margin-right: 45px;

            span {
              max-width: 50px;
              margin: 0 10px;
            }
          }
        }

        &.submit-btn {
          margin-top: 20px;
          border-top: 1px dotted #e4e4e4;
          padding: 20px;
        }
      }

      &.order-verify {
        .os-con-list {
          p {
            &:not(:first-child) {
              margin-left: 60px;
            }

            >span {
              max-width: 80px;
            }
          }
        }
      }

      .engineer-remark {
        align-items: flex-start;

        .remark-lists {
          flex: 1;
          margin: 0 10px;
          color: #6e6e6e;
          // background: #fff;

          .list {
            margin-bottom: 5px;
          }
        }
      }

      .switch-btn {
        justify-content: flex-start;
        align-items: flex-end;

        >.title {
          margin-right: 15px;
          margin-bottom: 2px;
        }
      }
    }
  }
}

.params-input {
  justify-content: flex-start;

  >* {
    margin-right: 20px;
    max-width: 200px;
  }
}

//V2 新加
.right {
  display: flex;
  align-items: center;
  // justify-content: end;
  // justify-content: space-between;
  width: 100%;
}

.right_li {
  margin-right: 20px;
  display: flex;
  align-items: center;
  width: 200px;

  span {}
}

.push_mes {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.cancelRemark_title {
  text-align: center;
  padding-bottom: 20px;
}

.cancelRemark_btn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.os-title2 {
  display: flex;
}

.right .btn-group {
  display: flex;
  justify-content: flex-end;
}

.html-context {
  background: rgb(245, 247, 250);
  min-height: 130px;
}
</style>
